<template>
    <div class="container">
        <!-- <div class="summary">
            <a-statistic
                title="当前可提现金额（元）"
                :value="data_summary.amount"
                style="margin-right: 50px"
            />

            <a-statistic
                title="处理中的提现金额（元）"
                :value="data_summary.amount_pend"
                style="margin-right: 50px"
            />

            <a-statistic
                title="累计成功提现金额（元）"
                :value="data_summary.amount_succeed"
                style="margin-right: 50px"
            />
        </div> -->
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <a-button class="item" type="primary" @click="on_create" icon="plus">退款申请</a-button>

                <a-divider type="vertical" class="item" />

                <a-radio-group
                    v-model="search.audit_status"
                    button-style="solid"
                    @change="(e) => on_field_change(e.target.value, 'audit_status')"
                >
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="1">处理中</a-radio-button>
                    <a-radio-button value="2">已同意</a-radio-button>
                    <a-radio-button value="3">已拒绝</a-radio-button>
                </a-radio-group>
            </div>

            <div class="right-items">
                <!-- <a-input-search
                    placeholder="搜索单号"
                    enter-button
                    @search="on_search"
                    class="item"
                    v-model="wd"
                />-->
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <!-- 状态 -->

                <!-- 状态 -->
                <template slot="audit_status" slot-scope="text, record">
                    <a-tag class="b-tag" v-if="text == 1">处理中</a-tag>
                    <a-tag color="green" class="b-tag" v-if="text == 2">已通过</a-tag>
                    <a-tag color="red" class="b-tag" v-if="text == 3">已拒绝</a-tag>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>
                <template slot="transaction" slot-scope="text, record">
                    <span style="color:#ff9800" v-if="record.reject_msg"
                        ><a-icon type="exclamation-circle" style="margin-right:4px;" />{{ record.reject_msg }}</span
                    >
                    <span v-else>{{ text }}</span>
                </template>
                <!-- 申请人 -->
                <template slot="user" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.user ? record.user.name : "-" }}
                        </div>
                        <div class="b">
                            {{ moment(record.created_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>
                <template slot="screenshot" slot-scope="text, record">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>
                <!-- 处理人 -->
                <template slot="executor" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.auditor ? record.auditor.name : "-" }}
                        </div>
                        <div class="b" v-if="record.executed_at">
                            {{ moment(record.executed_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button size="small" @click="on_cancel(record)" :disabled="record.audit_status != 1">撤销</a-button>
                    </div>
                </template>
            </a-table>
            <!-- <a-divider />

            <h2 class="h2"><a-icon type="info-circle" style="margin-right:12px" />使用说明</h2>

            <div class="explain-block">
                <ul>
                    <li>【余额退款】仅针对账户存在余额，且无任何后续消费意向的客户。</li>
                    <li>
                        若提交信息有误，请及时进行删除。如果申请已经得到部门主管审批通过，请及时联系财务进行取消。
                    </li>
                </ul>
            </div> -->
        </div>

        <!-- 新建 -->
        <modal_create :visible="visible_create" @close="visible_create = false" :callback="load" />
    </div>
</template>

<script>
    import moment from "moment";
    import modal_create from "./modal_create";
    import common_pagination from "../../../mixins/common_pagination.js";
    import commonjs from "../mixins/common";

    export default {
        mixins: [common_pagination, commonjs],
        components: { modal_create },
        data() {
            return {
                path: "/order/apply/refund",
                data_source: [],
                loading: false,
                selected_record: null,
                wd: null,
                search: { audit_status: "" },
                visible_create: false,
                data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
                columns: [
                    {
                        dataIndex: "audit_status",
                        width: 80,
                        title: "审批状态",
                        align: "center",
                        scopedSlots: {
                            customRender: "audit_status",
                        },
                    },
                    {
                        dataIndex: "transaction_no",
                        width: 180,
                        title: "流水号",
                        scopedSlots: {
                            customRender: "transaction",
                        },
                    },
                    {
                        dataIndex: "amount",
                        width: 120,
                        title: "退款金额/元",
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "member",
                        width: 100,
                        title: "退款客户",
                        scopedSlots: {
                            customRender: "member",
                        },
                    },
                    {
                        dataIndex: "user",
                        width: 120,
                        title: "申请人",
                        scopedSlots: {
                            customRender: "user",
                        },
                    },
                    {
                        dataIndex: "auditor.name",
                        width: 120,
                        title: "处理人",
                        scopedSlots: {
                            customRender: "executor",
                        },
                    },
                    {
                        dataIndex: "screenshot",
                        width: 120,
                        title: "付款截图",
                        scopedSlots: {
                            customRender: "screenshot",
                        },
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                    },
                    {
                        dataIndex: "failure_msg",
                        title: "结果",
                    },
                    {
                        dataIndex: "action",
                        width: 70,
                        align: "center",
                        fixed: "right",
                        title: "操作",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_order",
                value: "refund",
            });
            this.load();
            this.reset_query();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;

                this.wd = "wd" in query ? query["wd"] : "";
                this.search.audit_status = Object.prototype.hasOwnProperty.call(query, "audit_status") ? query["audit_status"] : "";
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/apply/refund?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_summary() {
                this.$http
                    .get(`/apply/refund/summary`)
                    .then((res) => {
                        if (res.success) {
                            this.data_summary = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_create() {
                this.visible_create = true;
            },
            on_cancel(record) {
                this.$confirm({
                    title: "是否撤销本次退款申请？",
                    centered: true,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .post("/apply/refund/cancel", { transaction_no: record.transaction_no })
                                .then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.load();
                                    } else {
                                        this.$error({
                                            title: "失败",
                                            content: res.message,
                                        });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .summary {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }
        .h2 {
            margin-top: 32px;
            margin-left: 16px;
        }
    }
</style>
